import {
  createApi, fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { defaultSerializeQueryArgs } from '../utils/serialize';
import type { RootState } from '../store';

const tagTypes = [
  'Groups',
  'Members',
  'Apps',
  'Layers',
  'Projects',
  'Batch',
  'Authorizations',
  'Attachments',
  'Webhooks',
];

export const baseApi = createApi({
  reducerPath: 'baseApiReducer',
  serializeQueryArgs: defaultSerializeQueryArgs,
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: (headers, { getState }) => {
      const { token } = (getState() as RootState).auth;

      // NOTE: this is unused. there is a story to utilize headers
      if (token) {
        headers.set('X-ApiToken', token);
      }
      return headers;
    },
  }),
  tagTypes,
  endpoints: () => ({}),
});

export const sendIDArray = (ids: string[]) => ids.map((id, idx, arr) => {
  if (idx === (arr.length - 1)) {
    return `id[]=${id}`;
  }
  return `id[]=${id}&`;
}).join('');

export const parameterize = (options: Record<string, any>) => {
  const params = new URLSearchParams();

  Object.entries(options).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => { params.append(`${key}[]`, item); });
    } else {
      params.append(key, value);
    }
  });

  return params.toString();
};

export default baseApi;
